import { checkIsInternalUser } from '@src/globalStore/profileStore';

/**
 * Gates Deep Mode UI + related "Deep" affordances.
 *
 * Today: Conviva-internal users only.
 * Future: This can be expanded to feature flags / entitlements without changing call sites.
 */
export const canSeeDeepModeFeatures = (): boolean => {
  return checkIsInternalUser();
};
